import { buildUrl } from "../util/integration"


import {
    authorizedFetch,
} from "./http_api";


/**
 * GET /tag/all
 *
 * Liefert alle im System verfügbaren Tags als TagDTO-Liste.
 */
export const fetchTagsAPI = (
    accessToken,
) => {
    return authorizedFetch(
        accessToken,
        buildUrl("tag/all"),
    );
};


/**
 * Aussagekräftiger Alias für Komponenten, die verfügbare Tags laden.
 */
export const fetchAvailableTagsAPI =
    fetchTagsAPI;